const { createRoot } = wp.element;
// eslint-disable-next-line no-unused-vars,import/no-unresolved
import ProductsComponent from './components/ProductsComponent';

const elements = document.querySelectorAll( '.js-qec-wc-products' );

if ( elements.length > 0 ) {
	elements.forEach( element => {
		const root = createRoot( element );
		root.render(
			<ProductsComponent attributes={ JSON.parse( element.dataset.attributes ) } config={ JSON.parse( element.dataset.config ) } />
		);
	} );
}

